
import { Component, Prop, toNative, Vue, Watch } from 'vue-facing-decorator';

@Component
class SideDrawer extends Vue {
  // Whether the drawer is visible
  @Prop() private showDrawer!: boolean;
  // Drawer heading
  @Prop() private title!: string;
  // Optional subtitle below the title
  @Prop({ default: '' }) private subtitle!: string;
  // Text for the cancel button
  @Prop({ default: '' }) private cancelButtonText!: string;
  // Text for the primary confirm button
  @Prop({ default: '' }) private confirmButtonText!: string;
  // Whether the confirm button is disabled
  @Prop({ default: false }) private confirmDisabled!: boolean;
  // Whether to show the footer
  @Prop({ default: true }) private showFooter!: boolean;
  // Panel width
  @Prop({ default: '520px' }) private width!: string;

  private localVisible = false;
  private localCancelText = '';
  private localConfirmText = '';
  private crossIcon = require('@/assets/Images/grey-cross-icon.svg');

  private mounted() {
    this.localVisible = this.showDrawer;
    this.localCancelText = this.cancelButtonText !== '' ? this.cancelButtonText : this.$t('CancelButton').toString();
    this.localConfirmText = this.confirmButtonText !== '' ? this.confirmButtonText : this.$t('SaveButton').toString();
  }

  @Watch('showDrawer')
  private OnShowDrawerChange(val: boolean) {
    this.localVisible = val;
    if (val) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  @Watch('cancelButtonText')
  private OnCancelTextChange(val: string) {
    if (val !== '') {
      this.localCancelText = val;
    }
  }

  @Watch('confirmButtonText')
  private OnConfirmTextChange(val: string) {
    if (val !== '') {
      this.localConfirmText = val;
    }
  }

  private Close() {
    document.body.style.overflow = '';
    this.$emit('close');
  }

  private Cancel() {
    document.body.style.overflow = '';
    this.$emit('cancel');
  }

  private Confirm() {
    this.$emit('confirm');
  }

  private beforeUnmount() {
    document.body.style.overflow = '';
  }
}

export default toNative(SideDrawer);
